(function ($) {
    var searchIcon = '.header__search button.search__openButton';
    var headerSearch = '.header__search';
    var closeButton = '.header__search .search__closeButton';
    var headerLogo = '.header__logo';
    var primaryNav = '.primaryNav';

    function activateHeaderSearch() {
        $(searchIcon).on('click tap', function () {
            $(headerSearch).addClass('search-open');
            $(headerLogo).addClass('search-open');
            $(primaryNav).addClass('search-open');
        });

        //Close button appears with css display on is-open
        $(closeButton).on('click tap', function () {
            $(headerSearch).removeClass('search-open');
            $(headerLogo).removeClass('search-open');
        });
    }

    activateHeaderSearch();

})(jQuery);
